import { create } from "zustand";
import { persist } from "zustand/middleware";

export interface MyLabel {
  address: string;
  label: string;
  contractType?: string;
}

interface MyLabelsState {
  labels: Record<string, MyLabel[]>; // networkId → entries
  add: (
    networkId: string,
    address: string,
    label: string,
    contractType?: string,
  ) => void;
  remove: (networkId: string, address: string) => void;
  list: (networkId: string) => MyLabel[];
  get: (networkId: string, address: string) => MyLabel | undefined;
}

const norm = (a: string) => a.toLowerCase();

export const useMyLabels = create<MyLabelsState>()(
  persist(
    (set, get) => ({
      labels: {},
      add: (networkId, address, label, contractType) =>
        set((s) => {
          const lc = norm(address);
          const current = s.labels[networkId] ?? [];
          const without = current.filter((e) => norm(e.address) !== lc);
          const next: MyLabel = { address: lc, label, contractType };
          return { labels: { ...s.labels, [networkId]: [...without, next] } };
        }),
      remove: (networkId, address) =>
        set((s) => ({
          labels: {
            ...s.labels,
            [networkId]: (s.labels[networkId] ?? []).filter(
              (e) => norm(e.address) !== norm(address),
            ),
          },
        })),
      list: (networkId) => get().labels[networkId] ?? [],
      get: (networkId, address) =>
        (get().labels[networkId] ?? []).find(
          (e) => norm(e.address) === norm(address),
        ),
    }),
    { name: "clustec-my-labels" },
  ),
);
